var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup324(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_324",
    "data-name": "Group 324",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 16.145,
    viewBox: "0 0 15 16.145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_127",
    "data-name": "Rectangle 127",
    width: 15,
    height: 16.145,
    fill: "currentColor"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    "data-name": "Group 323",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M92.91,123.228q0-3.981,0-7.962a.546.546,0,0,1,.22-.467q1.315-1.1,2.613-2.225c.1-.088.169-.1.276-.007q1.346,1.164,2.7,2.316a.29.29,0,0,1,.117.241q0,4,0,8.009c0,.031,0,.063-.007.094H97.5c0-.073-.011-.146-.011-.219q0-1.433,0-2.865c0-.286-.1-.4-.365-.4q-1.233-.006-2.467,0c-.264,0-.357.105-.357.368q0,1.3,0,2.6c0,.173-.005.346-.008.519Zm2.982-5.824h-.881c-.147,0-.294-.005-.44,0a.29.29,0,0,0-.294.288.3.3,0,0,0,.286.284,1.041,1.041,0,0,0,.126,0h2.39a.641.641,0,0,0,.2-.019.268.268,0,0,0,.213-.275.273.273,0,0,0-.235-.275.643.643,0,0,0-.156-.01H95.892",
    transform: "translate(-88.431 -107.083)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M227.936,207.205c0-.063-.012-.125-.012-.188q0-3.025,0-6.051c0-.236,0-.236.23-.236h3.24a.484.484,0,0,1,.549.551q0,2.883,0,5.767c0,.052-.006.1-.009.157Zm3.076-4.588h0c0-.115,0-.231,0-.346a.262.262,0,0,0-.271-.266.249.249,0,0,0-.279.253c-.009.236-.008.472,0,.707a.265.265,0,0,0,.267.256.273.273,0,0,0,.281-.259c.008-.115,0-.231,0-.346m-2.092,2.569c0,.11,0,.221,0,.331a.284.284,0,0,0,.281.282.274.274,0,0,0,.271-.273c.009-.231.008-.462,0-.692a.271.271,0,0,0-.276-.264.282.282,0,0,0-.274.271c-.006.115,0,.231,0,.346m2.092,0h0q0-.15,0-.3c0-.011,0-.021,0-.031a.283.283,0,0,0-.279-.282.272.272,0,0,0-.273.27c-.008.231-.008.462,0,.693a.274.274,0,0,0,.276.268.281.281,0,0,0,.275-.271c.007-.115,0-.231,0-.346m-2.092-2.564h0c0,.115-.006.231,0,.346a.275.275,0,0,0,.266.258.264.264,0,0,0,.282-.256c.01-.235.01-.472,0-.707a.248.248,0,0,0-.278-.254.263.263,0,0,0-.271.266c-.007.115,0,.23,0,.346",
    transform: "translate(-216.943 -191.06)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M.01,207.171c0-.063-.009-.126-.009-.188q0-2.853,0-5.706c0-.412.169-.58.583-.58,1.049,0,2.1,0,3.146,0,.127,0,.192.025.191.172q-.005,3.121,0,6.242c0,.021,0,.042-.005.063Zm1.439-4.6h0c0-.11,0-.22,0-.33a.264.264,0,0,0-.267-.271.252.252,0,0,0-.286.263c-.009.23-.008.461,0,.692a.266.266,0,0,0,.278.261.275.275,0,0,0,.272-.269c.006-.115,0-.231,0-.346m0,2.575h0q0-.158,0-.315c0-.011,0-.021,0-.031a.286.286,0,0,0-.28-.266.269.269,0,0,0-.27.254c-.01.236-.01.472,0,.708a.273.273,0,0,0,.276.268.284.284,0,0,0,.276-.287c0-.11,0-.22,0-.331m1.572,0h0c0-.121.007-.242,0-.362a.28.28,0,0,0-.273-.255.268.268,0,0,0-.274.25c-.01.241-.01.483,0,.724a.27.27,0,0,0,.269.257.282.282,0,0,0,.279-.267c.007-.115,0-.231,0-.346m0-2.577c0-.115.006-.231,0-.346a.262.262,0,0,0-.279-.258.245.245,0,0,0-.269.246c-.01.235-.01.472,0,.707a.265.265,0,0,0,.275.263.275.275,0,0,0,.275-.267c.007-.115,0-.231,0-.346",
    transform: "translate(0 -191.026)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M151.758,0a.346.346,0,0,1,.081.573q-.169.227-.344.449a.121.121,0,0,0,0,.178c.129.159.248.325.372.488a.33.33,0,0,1,.055.367.338.338,0,0,1-.333.192c-.623,0-1.246,0-1.869,0-.144,0-.2.04-.187.187.011.162,0,.325,0,.488,0,.1-.039.145-.139.143a3.075,3.075,0,0,0-.314,0c-.148.012-.2-.042-.2-.2.007-.75,0-1.5,0-2.251,0-.073,0-.147,0-.22a.4.4,0,0,1,.2-.4Z",
    transform: "translate(-141.709)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M135.935,277.666h-2.014q0-1.393-.01-2.786c0-.1.058-.122.142-.121q.872,0,1.745,0c.1,0,.146.034.145.137q-.005,1.386-.007,2.771",
    transform: "translate(-127.46 -261.521)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M72.875,75.728c-.029.038-.053.072-.08.1-.131.15-.268.3-.392.451-.075.094-.132.089-.218.015q-1.221-1.053-2.447-2.1c-.33-.284-.659-.569-.992-.85-.225-.19-.321-.186-.548.007q-1.712,1.46-3.421,2.925c-.112.1-.173.094-.26-.021a4.743,4.743,0,0,0-.358-.419c-.087-.091-.077-.145.018-.226q1.389-1.184,2.772-2.376c.47-.4.942-.8,1.408-1.21.088-.077.145-.085.237-.005q2.051,1.766,4.107,3.527a.594.594,0,0,1,.173.181",
    transform: "translate(-61.013 -68.497)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup324);
export default __webpack_public_path__ + "static/media/Group324.bca7ad165f7cff96ea807246d56ab528.svg";
export { ForwardRef as ReactComponent };